import {API_ENDPOINT}  from "./Api";
import requestInstance from "./Request";
import { setCurrentUser } from "utils/utils";

let env = process.env.REACT_APP_API_BASE_URL

export const  loginApi = async(user) => {
  const data = user || {};
  const res = await requestInstance.post(
    `${env}${API_ENDPOINT.Login.api}`,
    data
  )
  .catch((err) =>  err.response)
  return setCurrentUser(res)
}

